import * as React from 'react';
import { Section, Viewer } from '../../modules';
import { Parameter, ParameterFactory, Parametercategory } from '../../resource/'; 
import { RouteComponentProps } from 'react-router';
import { IAuthProps } from '../../services/Auth';

import { Tabs } from '@independent-software/typeui/controls/Tabs';
import { ToastService } from '@independent-software/typeui/controls/Toast';
import { Flex } from '@independent-software/typeui/controls/Flex';
import { Header } from '@independent-software/typeui/controls/Header';
import { Output } from '../../controls/Output';
import { Number } from '@independent-software/typeui/formatters/Number';
import { Label } from '@independent-software/typeui/controls/Label';

class ViewParameter extends React.Component<IAuthProps & RouteComponentProps<{id:string}>, {}> {
  private handleEdit = () => {
    this.props.history.push(`/parameters/edit/${parseInt(this.props.match.params.id)}`);
  }

  private handleDelete = () => {
    ToastService.toast("Parameter deleted.");
    this.props.history.push('/parameters');
  }    

  public handleCategoryClick = (category: Parametercategory) => {
    this.props.history.push(`/parametercategories/${category.id}`);
  }

  render() {
    let p = this.props;
    return (
      <Viewer<Parameter> 
        auth={p.auth}
        id={parseInt(p.match.params.id)}
        factory={ParameterFactory}
        canEdit='can_edit_parameters'
        canDelete='can_delete_parameters'
        onEdit={this.handleEdit}
        onDelete={this.handleDelete}
        content={(parameter: Parameter) => 
          <React.Fragment>
            <Section dark padded>
              <Header size="h1">{parameter.name} ({parameter.unit})</Header>
            </Section>
            <Tabs underlined>
              <Tabs.Pane label="General">
                <Section padded="very">
                  <Flex.Columns count={2}>
                    <>
                      <Output label="Name" hint="Parameter name">{parameter.name}</Output>
                      <Output label="Unit" hint="Parameter unit">{parameter.unit}</Output>
                      <Output label="Decimals" hint="Number of decimals"><Number value={parameter.decimals} decimals={0}/></Output>
                    </>
                    <>
                      <Output label="Type" hint="Parameter type">{parameter.type != null ? (parameter.type.charAt(0).toUpperCase() + parameter.type.slice(1)) : '-'}</Output>
                      <Output label="Formula" hint="Parameter Formula">{parameter.formula}</Output>
                    </>
                  </Flex.Columns>
                  <Output nobackground label="Categories">
                    {parameter.parametercategories.map(cat => 
                      <Label onClick={p.auth.hasRight('can_view_stationcategories') ?  () => this.handleCategoryClick(cat) : null} basic tag key={cat.id}>{cat.name}</Label>
                    )}
                  </Output>
                </Section>
              </Tabs.Pane>
              <Tabs.Pane label="Limits">
                <Section padded="very">
                  <Flex.Columns count={2}>
                    <>
                      <Output label="Minimum" hint="Minimum allowable value"><Number value={parameter.minvalue} decimals={parameter.decimals}/></Output>
                      <Output label="Maximum" hint="Maximum allowable value"><Number value={parameter.maxvalue} decimals={parameter.decimals}/></Output>
                    </>
                    <>
                      <Output label="Recommended minimum" hint="Recommended minimum allowable value"><Number value={parameter.recommended_low} decimals={parameter.decimals}/></Output>
                      <Output label="Recommended maximum" hint="Recommended maximum allowable value"><Number value={parameter.recommended_high} decimals={parameter.decimals}/></Output>
                    </>
                  </Flex.Columns>
                </Section>
              </Tabs.Pane>              
            </Tabs>
          </React.Fragment>}>
      </Viewer>
    );
  }
}

export { ViewParameter };
